import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    overflow: "hidden",
  },
  dialogTitle: {
    textTransform: "capitalize",
  },
  dialogContent: {
    flex: "1 1 auto",
    position: "relative",
    overflow: "auto",
  },

  recipientsSectionTitle: {
    marginBottom: theme.hv.spacing.sm,
  },
  templateSectionTitle: {
    marginBottom: theme.hv.spacing.sm,
  },
}));

export default useStyles;
